import React from 'react'

/* Styles */
import './ConfrontationSwitching.css'

/* Components */
import Confrontation from '../confrontation/Confrontation'

/* Modules */
import { Breadcrumb, Select, Avatar, Spin } from 'antd'
import { Link } from 'react-router-dom'
import TopBar from '../topBar/TopBar'

const ConfrontationSwitchingView = (props) => {

    let switchingList = props.switchingList.map(count => {
        return (
            <Select.Option value={count.n + 1} key={count.n}>
                <Avatar
                    style={{ width: '20px', height: '20px', backgroundColor: count.color }}
                ></Avatar>&nbsp; &nbsp;
                {count.n < 300 ? 'Chave ' + (count.n + 1) : count.n < 308 ? 'Chave Absoluto ' + (count.n - 299) : 'Chave Especial ' + (count.n - 307)}
            </Select.Option>
        )
    })

    return (
        <div id='champContent'>

            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId }}>
                            {props.champObject.nome}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId + '/confrontation' }}>
                            Confrontos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Chaves</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <p style={{ width: '100%', textAlign: 'center', fontSize: 'larger' }}>Confrontos das chaves</p>

            <div className='HomeContent'>
                {props.loadingSwitchingList ?
                    <Spin style={{ width: '100%', marginTop: '20px' }} />
                    :
                    <Select
                        showSearch
                        defaultValue={props.switchingId ? props.switchingId : undefined}
                        placeholder="Selecione uma chave"
                        className='SwitchingContainerSelect'
                        optionFilterProp="children"
                        onChange={props.chooseSwitching}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                        <Select.Option value={null}> </Select.Option>
                        {switchingList}
                    </Select>
                }
            </div>

            {
                props.switchingId ?
                    <Confrontation
                        champObject={props.champObject}
                        champId={props.champId}
                        switchingId={props.switchingId}
                        isScoreMan={props.isScoreMan}
                    /> :
                    null
            }
        </div>
    )
}

export default ConfrontationSwitchingView